import { useIntersectionObserver } from './useIntersectionObserver.js';

const useIsVisible = (elementRef, options) => {
  const entry = useIntersectionObserver(elementRef, options || {});
  return !!entry?.isIntersecting;
};
const useIsVisibleOnce = (elementRef, options) => {
  const entry = useIntersectionObserver(elementRef, {
    ...(options || {}),
    freezeOnceVisible: true
  });
  return !!entry?.isIntersecting;
};

export { useIsVisible, useIsVisibleOnce };
